import { Metadata, useTranslation } from "@harea/component";
import { TTimeOff } from "@harea/component"
import { useAppointmentEventColor } from "hooks/useAppointmentEventColor"

export const AppointmentDetailsType = (props: Props) => {

    const t = useTranslation()

    if (props.type) {
        return (
            <Metadata
                label={t("Project.DayOff.Type")}
                labelProps={{ 
                   className: '!mr-[15px] !w-auto'
                }}
                value={( 
                    <h3 className={`font-bold`}>{t(`Generic.de.${props?.type?.designation}`)}</h3>
                )}
            />
        )
    }

    return (
        <></>
    )
}

type Props = Partial<TTimeOff>
